import React from "react";
import "./Ceodb.scss";
import InsightSpeedometer from "../InsightMenu/InsightSpeedometer";

const OverviewPreview = () => {
    return (
        <div className="overview-preview">

            {/* ================= TOP ROW ================= */}
            <div className="top-row">
                {/* Cultural Index */}
                <div className="card cultural-index">
                    <div className="card-header">
                        <span>Cultural Index</span>
                        <i className="info">ⓘ</i>
                    </div>
                    <InsightSpeedometer />
                </div>

                {/* Today's Mood */}
                <div className="card todays-mood">
                    <div className="card-header">
                        <span>Today's Mood</span>
                        <i className="expand">⤢</i>
                    </div>

                    <div className="mood-content">
                        <p>Current Score: <strong>55</strong></p>
                        <div className="mood-icon">💬</div>
                    </div>
                </div>
            </div>

            {/* ================= MIDDLE ROW ================= */}
            <div className="middle-row">

                {/* Employee Speak */}
                <div className="card employee-speak">
                    <div className="card-header">
                        <span>Employee Speak</span>
                        <span className="live-dot">● Live</span>
                    </div>

                    <div className="speak-list">
                        {[
                            "I feel completely comfortable being myself at work.",
                            "The organization genuinely cares about me as a person.",
                            "In a very good mood today.",
                            "Everyone is treated equally regardless of gender.",
                            "Management supports taking time off.",
                            "Sometimes I hesitate to speak.",
                            "Care varies by department.",
                            "Fairness is average.",
                            "Leave is neither easy nor difficult.",
                            "I feel respected and accepted."
                        ].map((text, i) => (
                            <div key={i} className="speak-item">
                                <span className="dot"></span>
                                <span>{text}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right Side Cards */}
                <div className="right-cards">
                    <div className="mini-card">
                        <span className="title">Respect</span>

                        <div className="score-block">
                            <div className="score-line"></div>

                            <div className="score-values">
                                <span>42.5</span>
                                <span className="positive">+2.77</span>
                                <span>45.27</span>
                            </div>
                        </div>
                    </div>

                    <div className="mini-card">
                        <span className="title">Credibility</span>

                        <div className="score-block">
                            <div className="score-line"></div>

                            <div className="score-values">
                                <span>30</span>
                                <span className="positive">+8.51</span>
                                <span>38.51</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OverviewPreview;